// @flow
import React, { useEffect, useState, useCallback, useMemo, useRef } from 'react'
import * as DmsCommon from './../supports/dms-common';
import * as DmsService from './../supports/dms-service';
import { styled } from '@mui/material/styles';
import { GlobalEvent, GlobalState } from './GlobalContext'
import MsgDialog from './MsgDialog';
import DocDListGridEdit from './DocDListGridEdit';
import SelMemberDialog from './SelMemberDialog';
import UploadFilesProgress from './UploadFilesProgress';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from 'prop-types';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import { useForm, Controller } from "react-hook-form";
import SaveIcon from '@mui/icons-material/Save';
import Box from '@mui/material/Box';
import InputAdornment from '@mui/material/InputAdornment';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';




export default function DocRevAddDialog(props) {

  const { sysID, open, onClose, docDetail, afterUpdate } = props;

  // Get Global state and dispatcher
  const [gState, gStateDispatch] = React.useContext(GlobalState);

  const [gEvent, gEventDispatch] = React.useContext(GlobalEvent);

  const [showLoading, setShowLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const [distData, setDistData] = useState([]);

  const [anchorElAdd, setAnchorElAdd] = useState(null);
  const openAddDialog = Boolean(anchorElAdd);
  const handleAddClick = (event) => {
    setAnchorElAdd(event.currentTarget);
  };
  const handleCloseAddMenu = () => {
    setAnchorElAdd(null);
  };

  const [openAddUserDialog, setOpenAddUserDialog] = useState(false);
  const [allFolderUsers, setAllFolderUsers] = useState([]);
  // const [members, setMembers] = useState([]);
  const [groups, setGroups] = useState([]);

  const onCatchPromiseError = (e) => {
    const msg = typeof e === "string" ? e : (e?.errMsg || e?.message || "Unknown Error");
    setErrMsg(msg);
    setShowError(true);
    gEventDispatch({
      showErr: true,
      err: e,
    });
  }

  const initData = () => {
    setFile(null);

    // setFileName("");
    // setRemark("");
    setValue("fileName", "")
    setValue("remark", "")

    setDistData([]);
    setSelectedRecs([]);

  }

  useEffect(() => {

    if (open === true) {
      initData();

      const xFunc = async () => {
        try {
          const [vAllFolderUsers, , vGroups] =
            await DmsService.getFolderAccessibleUsersPromise(gState.sessionID, sysID, docDetail.FolderID);
          setAllFolderUsers(vAllFolderUsers);
          // setMembers(vMembers);
          setGroups(vGroups);

        } catch (e) {
          onCatchPromiseError(e);
        }


      }
      xFunc();
    }

  }, [open])

  const handleCloseClick = () => {
    // initData();

    onClose && onClose();
  }

  const handleAddByUser = async () => {
    setAnchorElAdd(null);

    setOpenAddUserDialog(true);
  };

  const handleSelectAddUsers = (aUsers, aGroups) => {
    // console.log("aUsers", aUsers);
    // console.log("aGroups", aGroups);

    setOpenAddUserDialog(false);

    let vData = distData.map(item => {
      return item
    });


    aUsers.forEach(addUser => {
      const vFound = vData.find(f => f.ToUserID.toLowerCase() === addUser.UserID.toLowerCase());
      if (!vFound) {
        // console.log("addUser", addUser);
        const vNewItem = {
          "ActionReq": 0,
          "DeptName": addUser.Department,
          "ToUserID": addUser.UserID,
          "ToUserName": addUser.FullName,
          "IsUser": true,
        }

        vData.push(vNewItem);

      }
    });

    aGroups.forEach(addGroup => {
      const vFound = vData.find(f => f.ToUserID.toLowerCase() === addGroup.GroupID.toLowerCase());
      if (!vFound) {
        // console.log("addUser", addUser);
        const vNewItem = {
          "ActionReq": 0,
          "DeptName": "",
          "ToUserID": addGroup.GroupID,
          // "ToUserName": addGroup.GroupNameDisplay,
          "ToUserName": addGroup.Name,
          "IsUser": false,
        }

        vData.push(vNewItem);

      }
    });

    // console.log("vData", vData);
    setDistData(vData);
    setSelectedRecs([]);

  }

  const handleAddAllAuthUsers = async () => {
    setAnchorElAdd(null);

    setShowLoading(true);

    try {

      let vData = distData.map(item => {
        return item
      });

      let vHasUpdate = false;

      // console.log("handleAddAllAuthUsers docDetail", docDetail);
      const vAll = (docDetail.Rights?.length == 0) || docDetail.Rights[0]?.UserOrGroupID == "*";


      if (vAll) {
        allFolderUsers.forEach(addUser => {
          const vFound = vData.find(f => f.ToUserID.toLowerCase() === addUser.UserID.toLowerCase());
          if (!vFound) {
            // console.log("addUser", addUser);
            const vNewItem = {
              "ActionReq": 0,
              "DeptName": addUser.Department,
              "ToUserID": addUser.UserID,
              "ToUserName": addUser.FullName,
              "IsUser": true,
            }

            vData.push(vNewItem);

            vHasUpdate = true;
          }
        });



      } else {
        docDetail.Rights.forEach(aRightRec => {
          const vFound = vData.find(f => f.ToUserID.toLowerCase() === aRightRec.UserOrGroupID.toLowerCase());
          if (!vFound) {
            // console.log("aRightRec", aRightRec);

            const vNewItem = {
              "ActionReq": 0,
              "DeptName": aRightRec.Dept,
              "ToUserID": aRightRec.UserOrGroupID,
              "ToUserName": aRightRec.Name,
              "IsUser": aRightRec.IsUser,
            }

            vData.push(vNewItem);

            vHasUpdate = true;
          }
        })
      }

      if (vHasUpdate === true) {
        // console.log("vData", vData);
        setDistData(vData);
        setSelectedRecs([]);
      }

      setShowLoading(false);
    } catch (e) {
      setShowLoading(false);
      setErrMsg(e.errMsg || e.message);
      setShowError(true);
    };





  };



  const handleActionChange = (aRecord, aNewValue) => {
    // console.log("handleActionChange", aCurIdx, aNewValue);

    const vNewGridData = distData.map((d, idx) => {
      if (d.ToUserID == aRecord.ToUserID) {
        return {
          ...d,
          "ActionReq": aNewValue,
        }
      } else {
        return d;
      }
    });

    setDistData(vNewGridData);
  };

  const handleRemove = () => {
    // console.log("handleRemove selectedRecs", selectedRecs);

    const vData = distData.filter(d => !selectedRecs.some(r => r.ToUserID === d.ToUserID));
    setDistData(vData);
    setSelectedRecs([]);

  }




  const [selectedRecs, setSelectedRecs] = useState([]);

  const handleSelectionChange = (aRecords) => {

    setSelectedRecs(aRecords);

  }



  const [openUploadProgress, setOpenUploadProgress] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const uploadFile = async (aFile) => {
    if (!aFile || aFile.size === 0) return "";
    if (aFile.size > DmsCommon.MAX_FILE_SIZE) {
      throw new Error("File size exceeds 2GB limit!");
    }
    setUploadProgress(0);
    const vFileID = await DmsService.uploadChunkedFilePromise(
      gState.sessionID,
      aFile,
      (progress) => setUploadProgress(progress)
    );
    return vFileID;
  }



  const [file, setFile] = useState(null);
  // const [updateFileName, setUpdateFileName] = useState("");
  // const [remark, setRemark] = useState("");

  const handleSelectedUploadFile = (e) => {
    const vFileList = e.target.files;
    // console.log("handleSelectedUploadFile", vFileList);

    if (vFileList.length > 0) {
      const vFile = vFileList[0];

      // setFileName(vFile.name);
      setValue("fileName", vFile.name)

      setFile(vFile);
    }

  }

  // Setup inital form values
  const defaultFormValues = {
    fileName: "",
    remark: "",
  }

  // React Hook the form
  const { control, handleSubmit, setValue, getValues, watch } = useForm({
    defaultValues: defaultFormValues
  });

  const watchFileName = watch("fileName");

  const onSubmit = data => {
    // console.log("onSubmit", data);

    if (file && file.size > DmsCommon.MAX_FILE_SIZE) {
      setErrMsg("File size exceeds 2GB limit!");
      setShowError(true);
      return;
    }

    const xFunc = async () => {
      try {
        setUploadProgress(0);
        setOpenUploadProgress(true);
        setShowLoading(true);

        const aFileID = await uploadFile(file);

        const vDistList = distData.map(d => {
          return {
            "UserID": d.ToUserID,
            "ActionReq": d.ActionReq,
          }
        })

        await DmsService.addDocRevPromise(gState.sessionID, sysID,
          docDetail.DocID, aFileID, file.name, file.size, data.remark, vDistList);

        setShowLoading(false);
        setOpenUploadProgress(false);

        // initData();
        afterUpdate && afterUpdate();
      } catch (e) {
        setShowLoading(false);
        setOpenUploadProgress(false);

        console.log('Fail: ', e);

        onCatchPromiseError(e);
      }



    }
    xFunc();

  }

  const submitBtnRef = useRef();

  const handleFormSubmit = () => {
    submitBtnRef?.current?.click();
  }

  const Input = styled('input')({
    display: 'none',
  });

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth={"xl"}
      aria-describedby="doc-add-revision-dialog-description"
    >
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <MsgDialog
        open={showError}
        title="Error"
        msgText={errMsg}
        onClose={() => setShowError(false)}
      />

      <UploadFilesProgress
        open={openUploadProgress}
        overAllProgress={uploadProgress}
        fileCount={1}
        curFileNo={1}
        curFilename={watchFileName}
      />

      <SelMemberDialog
        open={openAddUserDialog}
        onClose={() => { setOpenAddUserDialog(false) }}
        members={allFolderUsers}
        groups={groups}
        onSelect={handleSelectAddUsers}
      />

      <DialogTitle id="alert-dialog-title">
        Add Revision
      </DialogTitle>
      <DialogContent>

        <Box sx={{ display: 'flex', flexDirection: 'column', height: "70vh" }} component="form" onSubmit={handleSubmit(onSubmit)} >

          <Controller
            name="fileName"
            control={control}
            render={({ field }) =>

              <TextField
                label="Revision File"
                required
                fullWidth
                sx={{ m: 1 }}
                {...field}
                InputLabelProps={{ shrink: true, }}
                InputProps={{
                  readOnly: true,
                  endAdornment:
                    <InputAdornment position="end">
                      <label htmlFor="icon-button-add-rev-file">
                        <Input id="icon-button-add-rev-file" type="file" onChange={handleSelectedUploadFile} />
                        <Button variant="contained" component="span">
                          Select
                        </Button>
                      </label>
                    </InputAdornment>
                }}
              />

            }
          />


          <Controller
            name="remark"
            control={control}
            render={({ field }) =>

              <TextField
                label="Remark"
                fullWidth
                sx={{ m: 1 }}
                {...field}
                InputLabelProps={{ shrink: true, }}
              />

            }
          />



          Distribution List

          <Box sx={{ py: 1, px: 1 }} >
            <Button
              id="add-button"
              aria-controls="add-menu"
              aria-haspopup="true"
              aria-expanded={openAddDialog ? 'true' : undefined}
              startIcon={<PersonAddAlt1Icon />}
              onClick={handleAddClick}
            >
              Add
            </Button>
            <Menu
              id="add-menu"
              anchorEl={anchorElAdd}
              open={openAddDialog}
              onClose={handleCloseAddMenu}
              MenuListProps={{
                'aria-labelledby': 'add-button',
              }}
            >
              <MenuItem onClick={handleAddByUser}>Users</MenuItem>
              <MenuItem onClick={handleAddAllAuthUsers}>All Authorized Users</MenuItem>
            </Menu>

            <Button startIcon={<PersonRemoveIcon />} disabled={selectedRecs.length == 0} onClick={handleRemove}>
              Remove
            </Button>


          </Box>

          <DocDListGridEdit
            gridData={distData}
            onActionChange={handleActionChange}
            onSelectChange={handleSelectionChange}
          />

          {/* <Box sx={{ textAlign: 'right', mt: 1 }} >

          </Box> */}
          <Button type="submit" variant="contained" startIcon={<SaveIcon />} disabled={!file} sx={{ display: "none" }} ref={submitBtnRef}  >Save</Button>

        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseClick}>Cancel</Button>
        <Button variant="contained" startIcon={<SaveIcon />} disabled={!file} onClick={handleFormSubmit}  >Save</Button>

      </DialogActions>
    </Dialog>

  );
}

DocRevAddDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  sysID: PropTypes.string,
  docDetail: PropTypes.object,
  afterUpdate: PropTypes.func,
};
